import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  cities: () => client.get("/cities").then((r) => r.data),
  city: (slug) => client.get(`/cities/${slug}`).then((r) => r.data),
  developers: () => client.get("/developers").then((r) => r.data),
  projects: (params) => client.get("/projects", { params }).then((r) => r.data),
  investments: () => client.get("/investments").then((r) => r.data),
  articles: (params) => client.get("/articles", { params }).then((r) => r.data),
  article: (slug) => client.get(`/articles/${slug}`).then((r) => r.data),
  properties: (params) => client.get("/properties", { params }).then((r) => r.data),
  property: (slug) => client.get(`/properties/${slug}`).then((r) => r.data),
  compare: (slugs) => client.post("/properties/compare", slugs).then((r) => r.data),
  createLead: (payload) => client.post("/leads", payload).then((r) => r.data),
  parseSearch: (query) => client.post("/search/parse", { query }).then((r) => r.data),
  market: (slug) => client.get(`/market/${slug}`).then((r) => r.data),
  // auth
  me: () => client.get("/auth/me").then((r) => r.data),
  processSession: (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  myEnquiries: () => client.get("/me/enquiries").then((r) => r.data),
  // ai
  assistant: (message, session_id) => client.post("/assistant/chat", { message, session_id }).then((r) => r.data),
  localitySummary: (slug) => client.get(`/ai/locality-summary/${slug}`).then((r) => r.data),
  // uploads
  upload: (formData) => client.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  fileUrl: (path) => `${API}/files/${path}`,
  heroCampaigns: () => client.get("/public/hero-campaigns", { params: { t: Date.now() } }).then((r) => r.data),
  heroEvent: (id, type, button = "") => client.post(`/public/hero-campaigns/${id}/event`, { type, button }).catch(() => {}),
};

export default api;
